import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Session } from '@supabase/supabase-js';

interface AccountSettingsTabProps {
  session: Session;
}

export function AccountSettingsTab({ session }: AccountSettingsTabProps) {
  return (
    <div className="space-y-4 pt-4">
      <Card>
        <CardHeader>
          <CardTitle>계정 정보</CardTitle>
          <CardDescription>
            계정 정보를 관리하세요
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <div className="rounded-md bg-muted p-4">
              <p className="text-sm font-medium mb-1">이메일</p>
              <p className="text-base break-all">{session.user.email || '이메일 정보 없음'}</p>
            </div>
            <p className="text-xs text-muted-foreground">이메일 주소는 변경할 수 없습니다.</p>
          </div>
          <div className="space-y-2">
            <div className="rounded-md bg-muted p-4">
              <p className="text-sm font-medium mb-1">가입 일자</p>
              <p className="text-base">
                {new Date(session.user.created_at || '').toLocaleDateString('ko-KR', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}